import { BRAND_FAILURE, BRAND_REQUEST, BRAND_SUCCESS } from "../actions/actionTypes";

const initialState = {
  brands: [],
  loading: false,
  error: null,
};

const brandsReducer = (state = initialState, action) => {
  switch (action.type) {
    case BRAND_REQUEST:
      return { ...state, loading: true, error: null };
      
    case BRAND_SUCCESS:
      return { ...state, loading: false, brands: action.payload.data };

    case BRAND_FAILURE:
      return { ...state, loading: false, error: action.payload };

    default:
      return state;
  }
};

export default brandsReducer;
